import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Inject,
  NgModule,
  NgZone,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { OeAppService } from '../../shared/oe-app.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { SafeUrlPipeModule } from '../../pipes/safe-url.pipe';
import { DailyNewsEventType } from '../../shared/types/daily-news-events.enum';
import { ImmersionCourseService } from '../../shared/immersion-course.service';
import { CourseContentType } from '../../shared/types/course-content-type';
import { GenericModalService } from '../../shared/generic-modal/generic-modal.service';
import { MODAL_DATA } from '../../shared/tokens/modal-data.token';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { TranslatePipe, TranslatePipeModule } from '../../shared/translate.pipe';
import { UserwaySyncModule } from '../../shared/userway-sync.directive';
import { IframeActivityModalBase } from '../../shared/iframe-activity-modal/iframe-activity-modal.base';
import { IframeActivityModalData } from '../../shared/iframe-activity-modal/iframe-activity-modal-data';

export const DAILY_NEWS_MODAL_TITLE_ID = 'daily-news-modal-title';

@Component({
  selector: 'lp2-daily-news-modal',
  styleUrls: ['./daily-news-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  template: `
    <h2 id="${DAILY_NEWS_MODAL_TITLE_ID}" class="sr-only">{{ 'studybundle.news.title' | translate }}</h2>
    <iframe
      #iframe
      [lp2UserwaySync]="targetOrigin"
      *ngIf="url$ | async as url"
      [src]="url | safeUrl"
      frameborder="0"
      sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
      allow="autoplay; fullscreen"
      [height]="height"
      [attr.title]="'studybundle.news.title' | translate"
      class="daily-news-modal-iframe"
      data-test-id="daily-news-modal-iframe"
    >
    </iframe>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DailyNewsModalComponent extends IframeActivityModalBase {
  @HostBinding('class.daily-news-modal') readonly hostClass = true;
  @ViewChild('iframe') iframe: ElementRef<HTMLIFrameElement>;
  protected readonly closeEventType = DailyNewsEventType.DAILY_NEWS_CLOSE_EVENT;
  protected readonly heightEventType = DailyNewsEventType.DAILY_NEWS_HEIGHT_EVENT;
  protected readonly reportActivityProgressEventType = DailyNewsEventType.DAILY_NEWS_REPORT_ACTIVITY_PROGRESS_EVENT;
  protected readonly courseContentType = CourseContentType.DAILY_NEWS;

  constructor(
    private oeApp: OeAppService,
    private oeAppPersonService: OeAppPersonService,
    activeModal: NgbActiveModal,
    cdRef: ChangeDetectorRef,
    ngZone: NgZone,
    immersionCourseService: ImmersionCourseService,
    genericModalService: GenericModalService,
    translatePipe: TranslatePipe,
    @Inject(MODAL_DATA) modalData: IframeActivityModalData
  ) {
    super(activeModal, cdRef, ngZone, immersionCourseService, genericModalService, translatePipe, modalData);
  }

  protected getHost(): string {
    return this.oeApp.webDailyNewsHost;
  }

  protected buildUrl(): string {
    return `${this.oeApp.webDailyNewsHost}?env=${encodeURIComponent(this.oeApp.environment)}&url=${encodeURIComponent(
      this.modalData.item.url
    )}&lang=${encodeURIComponent(this.oeAppPersonService.preferredLang)}`;
  }
}

@NgModule({
  imports: [CommonModule, TranslatePipeModule, SafeUrlPipeModule, UserwaySyncModule],
  declarations: [DailyNewsModalComponent],
  entryComponents: [DailyNewsModalComponent],
  exports: [DailyNewsModalComponent],
})
export class DailyNewsModalModule {}



// WEBPACK FOOTER //
// ./ts/app/home/daily-news-modal/daily-news-modal.component.ts